export function Greeter() {

    let date = new Date(),
        hour = date.getHours(),

        greeting = function () {
            return hour < 12 ? "Good morning,"
                : hour >= 12 && hour <= 18 ? "Good afternoon,"
                    : "Good evening,"
        };

    $.each(document.querySelectorAll('.greeting'), function (i, element) {
        element.innerHTML = greeting();
    });
}